/** Fenêtre hydratation DD02 (corps + .eml) — pas la taille de la liste. */
export const INBOX_CACHE_WINDOW_SIZE = 50;

/** Alias bootstrap / sync dossiers standard (même fenêtre hydratée). */
export const INBOX_BOOTSTRAP_SIZE = INBOX_CACHE_WINDOW_SIZE;

/** Messages visibles avant « plus anciens » (en-têtes ; hydratation = 50). */
export const INBOX_LIST_SIZE = 100;

/** Extension manuelle (« afficher plus anciens ») — +50 par clic. */
export const INBOX_LOAD_MORE_SIZE = INBOX_CACHE_WINDOW_SIZE;

/** Nombre max de corps à préparer par requête (fenêtre DD02). */
export const INBOX_BODY_WARMUP_MAX = INBOX_CACHE_WINDOW_SIZE;

/** Délai avant le 1er warm corps en masse (liste déjà peinte). Nouveaux mails = 0 ms. */
export const INBOX_BODY_WARM_DEFER_MS = 400;

/** Corps hydratés par vague client via bodies-bootstrap.php (DD02 only). */
export const INBOX_BODIES_BOOTSTRAP_PAGE = 25;

/**
 * Hydratation client opportuniste (ouverture instantanée) :
 * max 50 corps, vagues de 25, plus récents d’abord — jamais bloquant UI/nav.
 */
export const INBOX_CLIENT_HYDRATE_MAX = 50;
export const INBOX_CLIENT_HYDRATE_WAVE = INBOX_BODIES_BOOTSTRAP_PAGE;
/** Pause entre deux vagues pour laisser respirer le main thread / la nav. */
export const INBOX_CLIENT_HYDRATE_WAVE_GAP_MS = 120;

/** Délai avant IMAP incrémental après hit DD02 (laisser peindre + bootstrap corps). */
export const INBOX_POST_CACHE_HIT_IMAP_DEFER_MS = 2_500;

/** Corps préparés par vague IMAP (évite 100 d’un coup). */
export const INBOX_BODY_WARM_BATCH = 5;

/** Pause entre deux vagues de warm (nouveaux mails = gap court côté bodyWarmup). */
export const INBOX_BODY_WARM_BATCH_GAP_MS = 250;

/** Re-poll pastilles vertes après nouveaux mails / warm (ms) — dossier courant seulement. */
export const INBOX_BODY_STATUS_RETRY_MS = [1000, 3000, 8000, 15000, 30000, 60000] as const;

/**
 * Après warm-bodies `queued` (worker) : poll bodies-status jusqu’à DD02 prêt.
 * Les retries classiques (15 s) sont trop courts si le worker est derrière une archive.
 */
export const INBOX_QUEUED_WARM_POLL_MS = 2_500;
export const INBOX_QUEUED_WARM_POLL_MAX_MS = 180_000;

/** Resync dossiers secondaires (Sent, Trash…) — app ouverte (ms). */
export const MAIL_BACKGROUND_SYNC_MS = 10 * 60 * 1000;

/** Poll unifié app ouverte : notifs cron + lecture DD02 + IMAP incrémental (ms). */
export const MAIL_LIVE_SYNC_MS = 5 * 60 * 1000;

/** Délai avant les dossiers autres que celui qui est ouvert. La réception part tout de suite. */
export const MAIL_LIVE_SYNC_INITIAL_DELAY_MS = 20_000;

/** Pause entre dossiers lors du bootstrap (ms). */
export const INBOX_BOOTSTRAP_FOLDER_GAP_MS = 200;

/** Délai avant prefetch en-têtes de tous les dossiers (après bootstrap prioritaire). */
export const FOLDER_HEADERS_PREFETCH_DEFER_MS = 5_000;

/** Délai avant prefetch DD02 INBOX multicompte (après peinture compte actif). */
export const MULTI_ACCOUNT_INBOX_PREFETCH_DEFER_MS = 5_000;

/** Délai avant 1er poll IMAP multicompte complet (tous comptes). */
export const MULTI_ACCOUNT_INBOX_BACKGROUND_SYNC_INITIAL_MS = 12_000;

/** Dossiers synchronisés en priorité au démarrage : INBOX + Sent + Drafts + Trash + Junk. */
export const INBOX_BOOTSTRAP_PRIORITY_COUNT = 5;

/** Priorité IMAP max incluse dans le bootstrap standard (Sent=1, Drafts=2, Trash=3, Junk=4). */
export const MAIL_STANDARD_FOLDER_MAX_PRIORITY = 4;
